import { s3TimeKeyToDate } from '@iotv/datamodel-core';
export const SystemReportTimeKeyToTimestamp = (timekey) => {
    let timestampOut = undefined;
    if (timekey) {
        const timeKeyElements = timekey.replace('system/operation/', '').split('/');
        const timeKeyArr = ['', '', '', '', '00', '00', '00'];
        timeKeyArr.splice(0, timeKeyElements.length, ...timeKeyElements);
        timestampOut = s3TimeKeyToDate(timeKeyArr).valueOf();
    }
    return timestampOut;
};
